document.addEventListener('DOMContentLoaded', () => {
  // Find the current product section and elements
  const section =
    document.querySelector('section[id^="MainProduct-"]') ||
    document.querySelector('[id^="MainProduct-"]')?.closest('section') ||
    document;

  const bar = section.querySelector('.ps-sticky-atc');
  if (!bar) return;

  const btnSticky = bar.querySelector('.ps-sticky-atc__btn');
  const priceSticky = bar.querySelector('#ps-sticky-price');

  // Locate the main product form & add-to-cart button
  const productForm = section.querySelector('product-form form, form[action*="/cart/add"]');
  const btnMain = section.querySelector('product-form button[name="add"], form[action*="/cart/add"] [type="submit"]');

  if (!productForm || !btnMain) return;
  
  // Copy the main ATC button's styles so the sticky CTA matches the theme
try {
  const cs = getComputedStyle(btnMain);
  if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)') {
    btnSticky.style.backgroundColor = cs.backgroundColor;
    btnSticky.style.color = cs.color || '#fff';
    btnSticky.style.borderRadius = cs.borderRadius || '9999px';
    btnSticky.style.border = cs.border || '0';
  }
} catch (_) {}


  // Helper: show/hide bar only when main ATC is off-screen
  const io = new IntersectionObserver(
    entries => {
      const inView = entries[0].isIntersecting;
      bar.classList.toggle('ps-sticky-atc--show', !inView);
      bar.setAttribute('aria-hidden', inView ? 'true' : 'false');
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
  );
  io.observe(btnMain);

  // Keep price in sync with the main price element
  const priceEl =
    section.querySelector('.price .price__sale .price-item--sale') ||
    section.querySelector('.price .price-item--regular') ||
    section.querySelector('.price');

  if (priceEl && priceSticky) {
    const updatePrice = () => (priceSticky.textContent = priceEl.textContent.trim());
    updatePrice();
    if ('MutationObserver' in window) {
      const mo = new MutationObserver(updatePrice);
      mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }

  // Mirror disabled state (sold out / processing)
  const syncDisabled = () => {
    const disabled = btnMain.hasAttribute('disabled') || btnMain.classList.contains('disabled');
    btnSticky.disabled = disabled;
  };
  syncDisabled();
  if ('MutationObserver' in window) {
    const mo2 = new MutationObserver(syncDisabled);
    mo2.observe(btnMain, { attributes: true, attributeFilter: ['disabled', 'class'] });
  }

  // When sticky button is clicked, submit the existing form (keeps theme JS/cart drawer intact)
  btnSticky.addEventListener('click', (e) => {
    e.preventDefault();
    // If the main button is visible (e.g., user scrolled back), prefer clicking it
    btnMain.click();
  });
});
